module.exports = __webpack_public_path__ + "img/new-striped-bass.eda338a6.png";